const priceFormat = (price) => parseFloat(price)
    .toLocaleString('ru-RU', {style: 'currency', currency: 'RUB', minimumFractionDigits: 2})
    .replace(/,+/g, '.').replace(/\s+/g, ',').replace(',₽', '');

export default priceFormat


// WEBPACK FOOTER //
// ./src/mixins/priceFormat.js